import { render, staticRenderFns } from "./iconTelegram.vue?vue&type=template&id=af070a08"
import script from "./iconTelegram.vue?vue&type=script&lang=js"
export * from "./iconTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports